import { Injectable } from "@angular/core";
import { WeGoConfig } from "../../shared/config";
import { AuthService } from "./../../shared/models/auth.service";
import { Http, RequestOptions } from "@angular/http";

@Injectable()
export class CreditCardPaymentService {
  //private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) {}

  public GetVerifyRedirectedUrlForPayment(transactionId: string) {
    let getVerifyRedirectedUrlForPaymentUrl =
      WeGoConfig.API_GET_VERIFY_REDIRECT_FOR_PAYMENT;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    getVerifyRedirectedUrlForPaymentUrl =
    getVerifyRedirectedUrlForPaymentUrl +
      "?transactionKey=" +
      transactionId;

    return this.http
      .post(getVerifyRedirectedUrlForPaymentUrl, transactionId, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/creditcardpaymentpopup/models/credit-card-payment.service.ts